import { extendTheme, withDefaultColorScheme, type ThemeConfig } from '@chakra-ui/react';
import { generatePalette } from 'utils/colors';
import components from './components';
import { getBrandColor } from 'utils/brandColor';

const config: ThemeConfig = {
  initialColorMode: 'light',
  useSystemColorMode: false,
};

const primaryColor = getBrandColor();
const buttonBorderRadius = `${mondayMindbody?.customization?.buttonBorderRadius ?? 0}px`;

// Ajout de styles personnalisés pour le composant Button
const buttonStyles = {
  variants: {
    contained: {
      color: 'white', // Texte blanc pour une meilleure lisibilité
      bg: primaryColor,
      borderRadius: buttonBorderRadius,
      textTransform: 'uppercase',
      _hover: {
        bg: 'primary.600', // Légèrement plus foncé au survol
      },
      _active: {
        bg: 'primary.700', // Encore plus foncé lorsqu'il est activé
      },
      _disabled: {
        bg: 'primary.500', // Couleur du fond pour le bouton désactivé
        color: 'white', // Couleur du texte pour le bouton désactivé
        opacity: 0.6, // Opacité pour le bouton désactivé
        _hover: {
          bg: 'primary.500 !important', // Couleur du fond pour le bouton désactivé
          color: 'white !important', // Couleur du texte pour le bouton désactivé
          opacity: '0.6 !important', // Opacité pour le bouton désactivé
        },
      },
    },
  },
};

const theme = extendTheme(
  {
    config,
    colors: {
      primary: generatePalette(primaryColor),
    },
    components: {
      ...components,
      Button: {
        ...buttonStyles, // Ajout des styles personnalisés pour Button
      },
      Input: {},
    },
    fontSizes: {
      xxl: '25px',
      xxxl: '40px',
    },
  },
  withDefaultColorScheme({
    colorScheme: 'primary',
  }),
);

export default theme;
